module.exports = __webpack_public_path__ + "static/angel-c034457c997a63f344d30e64842be74e.jpg";